import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import { clearCart } from "../../../slices/cart/publicOrderingCartSlice";

import esewaImg from "../../../assets/publicOrderingLogo/esewa.jpg";
import khaltiImg from "../../../assets/publicOrderingLogo/khalti.png";
import connectIps from "../../../assets/publicOrderingLogo/connectips.png";
import cashondelivery from "../../../assets/publicOrderingLogo/cashondelivery.jpeg";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import playBeep from "./PlayBeep";
import ConnectIpsServices from "../services/connectIpsServices";
import { submitConnectIpsForm } from "./connectIps";
import PaymentTypeServices from "../../../services/OrderingServices/PaymentTypeService";
import PublicOrderingServices from "../services/PublicOrderingServices";

import logo from "../../../assets/orderingSystem/logo.png";
import toast from "react-hot-toast";
// import PublicOrderingServices from "../../../services/OrderingServices/PublicOrderingServices";

const paymentImages = {
  CashOnDelivery: cashondelivery,
  "Cash On Delivery": cashondelivery,
  ConnectIPS: connectIps,
  "Connect IPS": connectIps,
  Esewa: esewaImg,
  Khalti: khaltiImg,
};

const CustomerCheckout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orgcode } = useParams();
  const location = useLocation();

  const orderResponse =
    location.state?.orderResponse ||
    JSON.parse(localStorage.getItem("orderResponse"));
  console.log("🚀 ~ CustomerCheckout ~ orderResponse:", orderResponse);

  const orderId = orderResponse?.orderRefrenceId;
  // const orderCode = orderResponse?.id;
  // console.log("🚀 ~ CustomerCheckout ~ orderCode:", orderCode)
  const orgData =
    location.state?.orgData || JSON.parse(localStorage.getItem("orgData"));
  console.log("🚀 ~ CustomerCheckout ~ orgData:", orgData);

  const [wsStatus, setWsStatus] = useState(""); // ENTR, PARSED, COMPLETED, FAILED
  const [wsMessage, setWsMessage] = useState("");
  const [wsLogs, setWsLogs] = useState([]);
  const wsRef = useRef(null);

  // Helper function for logging
  const addLog = (message) => {
    const timestamp = new Date().toLocaleTimeString();
    setWsLogs((prev) => [...prev, `${timestamp} | ${message}`]);
  };

  const [isPaying, setIsPaying] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paymentType, setPaymentType] = useState(
    location.state?.paymentType ||
      localStorage.getItem("paymentType") ||
      "CashOnDelivery",
  );

  // QR modal state
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrResponse, setQrResponse] = useState(null);
  console.log("🚀 ~ CustomerCheckout ~ qrResponse:", qrResponse);
  const [qrLoading, setQrLoading] = useState(false);

  const [checkStatusLoading, setCheckStatusLoading] = useState(false);
  const token = localStorage.getItem("CustomerInfo")
    ? JSON.parse(localStorage.getItem("CustomerInfo")).accessToken
    : null;
  console.log("🚀 ~ CustomerCheckout ~ token:", token);

  // Fetch payment methods from API
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        setLoading(true);
        const response =
          await PaymentTypeServices.onlineOrderPaymentTypeGetList(
            token,
            orgcode,
          );
        console.log("🚀 ~ fetchPaymentMethods ~ response:", response);

        const transformedMethods = response.map((method) => ({
          id: method.id, // numeric ID from backend
          key: method.name.replace(/\s+/g, ""), // for UI selection
          label: method.name,
          description: method.description || "Payment method",
          imagePath: method.displayImage || method.imagePath,
        }));

        setPaymentMethods(transformedMethods);

        // Set default payment type if not already set
        if (!paymentType && transformedMethods.length > 0) {
          setPaymentType(transformedMethods[0].key);
        }
      } catch (error) {
        console.error("Error fetching payment methods:", error);
        setPaymentMethods([
          {
            id: 0,
            key: "CashOnDelivery",
            label: "Cash on Delivery",
            description: "Pay when you receive your order",
          },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentMethods();
  }, []);

  // Store selected payment type in localStorage
  useEffect(() => {
    if (paymentType) {
      localStorage.setItem("paymentType", paymentType);
    }
  }, [paymentType]);

  // Add this helper function for status colors
  const getStatusColor = () => {
    switch (wsStatus) {
      case "CONNECTED":
        return "#2196F3";
      case "ENTR":
        return "#FF9800";
      case "PARSED":
        return "#FF9800";
      case "COMPLETED":
        return "#4CAF50";
      case "FAILED":
      case "ERROR":
        return "#F44336";
      default:
        return "#757575";
    }
  };

  // Add this helper function for status icons
  // const getStatusIcon = () => {
  //   switch (wsStatus) {
  //     case "CONNECTED":
  //       return "⏳";
  //     case "ENTR":
  //       return "📱";
  //     case "PARSED":
  //       return "⚙️";
  //     case "COMPLETED":
  //       return "✅";
  //     case "FAILED":
  //     case "ERROR":
  //       return "❌";
  //     default:
  //       return "🔌";
  //   }
  // };

  // Add this WebSocket useEffect (place it after your other useEffects)
  // Add this WebSocket useEffect (place it after your other useEffects)
  useEffect(() => {
    if (!qrModalOpen || !qrResponse) return;

    // Extract request_id from your QR response
    const requestId =
      qrResponse?.validationTraceId ||
      qrResponse?.request_id ||
      qrResponse?.requestId ||
      qrResponse?.data?.validationTraceId ||
      qrResponse?.data?.request_id;

    // const merchantId = "4501TVOI3XX"; // Your merchant ID
    const merchantId = "terminal1";

    const orderRefId = orderId;

    if (!requestId) {
      addLog("⚠️ No request_id found in QR response");
      console.log("QR Response:", qrResponse); // Debug log
      return;
    }

    // Build WebSocket URL (EXACTLY like your HTML file)
    // const serverUrl = `${window.APP_CONFIG.connectIpsWsUrl}/ws/qrstatus`;
    const serverUrl = "wss://api-uat-cloud.restroorder.com/ws/qrstatus";
    // let wsUrl = `${serverUrl}?request_id=${requestId}`;
    let wsUrl =
      `${serverUrl}` +
      `?request_id=${encodeURIComponent(requestId)}` +
      `&order_ref_id=${encodeURIComponent(orderRefId)}` +
      `&api_key=${encodeURIComponent(orgcode)}`;

    if (merchantId) wsUrl += `&merchant_id=${merchantId}`;

    addLog(`🔌 Connecting to WebSocket: ${wsUrl}`);

    try {
      // Create WebSocket connection
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;

      ws.onopen = () => {
        addLog("✅ WebSocket connected successfully");
        setWsStatus("CONNECTED");
        setWsMessage("Connected to server – Waiting for NCHL updates...");
      };

      ws.onmessage = (event) => {
        addLog(`📨 Received: ${event.data}`);

        try {
          const data = JSON.parse(event.data);
          setWsStatus(data.status);
          setWsMessage(data.message || "");

          // Handle different status updates
          if (data.status === "ENTR") {
            addLog("🔵 QR Code Scanned!");
            setWsMessage("Scan QR Code for payment...");
          } else if (data.status === "PARSED") {
            addLog("🟠 Payment being processed...");
            setWsMessage("Payment data received - Verifying...");
          } else if (
            data.status === "COMPLETED" &&
            data.debit_status === "000"
          ) {
            addLog("✅ Payment Successful!");
            setWsMessage("Payment completed successfully!");
            playBeep();

            setTimeout(() => {
              ws.close();
              dispatch(clearCart());
              navigate(`/payment-success`, {
                state: { orgData, orderResponse, paymentType },
              });
            }, 2000);
          } else if (data.status === "FAILED") {
            addLog("❌ Payment Failed");
            setWsMessage(data.message || "Payment failed");

            setTimeout(() => {
              ws.close();
              navigate(`/payment-error`, {
                state: {
                  orgData,
                  orderResponse,
                  paymentType,
                  reason: data.message || "Payment failed",
                },
              });
            }, 2000);
          }
        } catch (e) {
          addLog(`⚠️ Received non-JSON message: ${event.data}`);
          setWsMessage("Received non-JSON message");
        }
      };

      ws.onerror = (err) => {
        addLog("❌ WebSocket error occurred");
        console.error("WebSocket error:", err);
        setWsStatus("ERROR");
        setWsMessage("Connection Error – Check server/console");
      };

      ws.onclose = (event) => {
        addLog(
          `🔌 Connection closed (code: ${event.code}, reason: ${
            event.reason || "none"
          })`,
        );
        if (wsStatus !== "COMPLETED") {
          setWsStatus("DISCONNECTED");
          setWsMessage("Disconnected");
        }
      };
    } catch (error) {
      addLog(`❌ Failed to connect: ${error.message}`);
      console.error("WebSocket connection error:", error);
      setWsStatus("ERROR");
      setWsMessage("Failed to connect to payment server");
    }

    // Cleanup function
    return () => {
      if (wsRef.current) {
        addLog("🔌 Cleaning up WebSocket connection");
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  }, [qrModalOpen, qrResponse]);

  const getPaymentTypeId = () => {
    const method = paymentMethods.find((m) => m.key === paymentType);
    return method?.id || 0;
  };

  const total = orderResponse?.totalAmount || 0;

  const isCOD =
    paymentType === "CashOnDelivery" || paymentType === "Cash On Delivery";

  const handleCheckNqrStatus = async () => {
    try {
      setCheckStatusLoading(true);

      const validationTraceId =
        qrResponse?.validationTraceId || qrResponse?.request_id;
      const merchantId = "string";
      const acquirerId = "string";

      if (!validationTraceId) {
        toast.error("Validation Trace ID not found");
        return;
      }

      const response = await PublicOrderingServices.checkNqrtReport({
        validationTraceId,
        merchantId,
        acquirerId,
      });
      console.log("🚀 ~ handleCheckNqrStatus ~ response:", response);
      console.log("🚀 ~ NQR Report Response:", response);
      console.log("🚀 ~ responseDescription:", response?.responseDescription);

      // Show toast with response description
      toast.success(
        response?.responseDescription || "Status checked successfully",
      );
    } catch (error) {
      console.error("Check NQR Status Error:", error);
      const errorMsg =
        error?.responseDescription ||
        error?.message ||
        "Failed to check status";
      console.log("🚀 ~ Showing error toast:", errorMsg);
      toast.error(errorMsg);
    } finally {
      setCheckStatusLoading(false);
    }
  };

  // ✅ Corrected handlePayment
  const handlePayment = async () => {
    playBeep();

    const paymentTypeId = getPaymentTypeId();

    try {
      setIsPaying(true);

      // 1️⃣ MARK ORDER AS PAID
      await PublicOrderingServices.markOnlineOrderPaid({
        orderId,
        paymentTypeId,
        amount: total,
        remarks: paymentType,
        apikey: orgcode,
        token,
      });
      console.log("✅ Order marked as paid");

      // 2️⃣ CONNECT IPS FLOW
      if (paymentType === "ConnectIPS" || paymentType === "Connect IPS") {
        const response = await ConnectIpsServices.getConnectIpsToken(
          orderId,
          orgcode,
        );
        console.log("🚀 ~ handlePayment ~ orderId:", orderId);
        submitConnectIpsForm(response);
        return;
      }

      // 2.5️⃣ QR CODE FLOW
      // If selected payment type is QRCode (stored as "QRCode" in localStorage), generate QR
      if (paymentType === "QRCode" || paymentType === "QR Code") {
        try {
          setQrLoading(true);
          setWsLogs([]); // Clear previous logs
          setWsStatus("");
          setWsMessage("");

          const payload = {
            orderRefNumber: orderId,
            // pointOfInitialization: 12,
            // transactionAmount: total,
            storeLabel: "store1",
            terminalLabel: "terminal1",
            purposeOfTransaction: "billpayment",
            qrImage: true,
          };

          const resp = await ConnectIpsServices.generateQR(payload, orgcode);
          console.log("✅ generateQR resp:", resp);

          setQrResponse(resp?.data ?? resp);
          setQrModalOpen(true);
          return;
        } catch (err) {
          console.error("Generate QR failed:", err);
          navigate(`/payment-error`, {
            state: {
              orgData,
              orderResponse,
              paymentType,
              reason: err?.message || "QR generation failed",
            },
          });
          return;
        } finally {
          setQrLoading(false);
        }
      }

      // 3️⃣ CASH ON DELIVERY SUCCESS
      dispatch(clearCart());
      navigate(`/payment-success`, {
        state: { orgData, orderResponse, paymentType },
      });
    } catch (error) {
      console.error("❌ Payment failed:", error);

      navigate(`/payment-error`, {
        state: {
          orgData,
          orderResponse,
          paymentType,
          reason: error?.message || "Payment failed",
        },
      });
    } finally {
      setIsPaying(false);
    }
  };

  if (!orderResponse) {
    return (
      <Container className="py-4">
        <Card>
          <CardBody>
            <h5>No order found</h5>
            <Button
              onClick={() => {
                playBeep();
                navigate(`/${orgcode}`);
              }}
            >
              Back to Menu
            </Button>
          </CardBody>
        </Card>
      </Container>
    );
  }

  const items = orderResponse.items || [];
  const orderDetails = orderResponse.orderDetails || [];
  console.log("🚀 ~ CustomerCheckout ~ orderDetails:", orderDetails);
  console.log("🚀 ~ CustomerCheckout ~ items:", items);

  return (
    <Container className="py-4" style={{ maxWidth: 1200 }}>
      <Header orgData={orgData} />

      <Row className="mt-4">
        <Col lg={8}>
          <Card
            style={{ border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
          >
            <CardBody style={{ padding: "24px" }}>
              <h5
                className="mb-4"
                style={{ fontWeight: 600, fontSize: "18px" }}
              >
                Payment Method
              </h5>

              {loading ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                  <p className="mt-2 text-muted">Loading payment methods...</p>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {paymentMethods.map((method) => (
                    <div
                      key={method.id}
                      onClick={() => {
                        playBeep();
                        !isPaying && setPaymentType(method.key);
                      }}
                      style={{
                        border:
                          paymentType === method.key
                            ? "2px solid #f85606"
                            : "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: "16px",
                        cursor: isPaying ? "not-allowed" : "pointer",
                        backgroundColor:
                          paymentType === method.key ? "#fff5f0" : "white",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          border:
                            paymentType === method.key
                              ? "6px solid #f85606"
                              : "2px solid #d0d0d0",
                          flexShrink: 0,
                        }}
                      />
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "15px",
                            marginBottom: "4px",
                          }}
                        >
                          {method.label}
                        </div>
                        <div style={{ fontSize: "13px", color: "#757575" }}>
                          {method.description}
                        </div>
                      </div>
                      {(paymentImages[method.key] ||
                        paymentImages[method.label]) && (
                        <img
                          src={
                            paymentImages[method.key] ||
                            paymentImages[method.label]
                          }
                          alt={method.label}
                          style={{
                            height: "32px",
                            width: "auto",
                            objectFit: "contain",
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </CardBody>
          </Card>
        </Col>

        {/* RIGHT: Order Summary */}
        <Col lg={4}>
          <Card
            style={{ border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
          >
            <CardBody style={{ padding: "24px" }}>
              <h5 className="mb-4">Order Summary</h5>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>Total Products</span>
                  <span>
                    {[...(items || []), ...(orderDetails || [])].reduce(
                      (sum, it) => sum + (it.qty ?? it.quantity ?? 0),
                      0,
                    )}
                  </span>
                </div>
              </div>

              <div className="d-flex justify-content-between mb-3">
                <strong>Total</strong>
                <strong style={{ color: "#f85606" }}>
                  Rs. <NumberWithCommas number={total} />
                </strong>
              </div>

              <Row>
                <Col>
                  <Button
                    color="primary"
                    onClick={() => {
                      playBeep();
                      navigate(`/${orgcode}`);
                    }}
                    disabled={isPaying}
                    className="mt-2 w-100"
                  >
                    Back to Menu
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      playBeep();
                      handlePayment();
                    }}
                    disabled={isPaying || loading}
                    style={{
                      width: "100%",
                      backgroundColor: "#f85606",
                      border: "none",
                    }}
                    className="mt-2 w-100"
                  >
                    {isPaying ? "Processing.." : isCOD ? "Checkout" : "Pay"}
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* QR Modal */}
      <Modal
        isOpen={qrModalOpen}
        toggle={() => {
          if (wsStatus !== "COMPLETED") {
            setQrModalOpen(false);
            wsRef.current?.close();
          }
        }}
        centered
        size="md"
      >
        <ModalHeader
          toggle={() => {
            if (wsStatus !== "COMPLETED") setQrModalOpen(false);
          }}
        >
          QR Payment
        </ModalHeader>

        <ModalBody>
          {qrLoading ? (
            <div className="text-center py-5">
              <Spinner />
              <p className="mt-3">Generating QR Code...</p>
            </div>
          ) : (
            <>
              {/* QR STAND CARD */}
              <div
                style={{
                  maxWidth: "360px",
                  margin: "0 auto",
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  padding: "20px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                  textAlign: "center",
                }}
              >
                {/* Merchant / Bank Logo */}
                <div style={{ marginBottom: "10px" }}>
                  <img
                    src={"/NepalPay.png"}
                    // alt="Merchant Logo"
                    style={{ height: "50px", objectFit: "contain" }}
                  />
                </div>

                {/* NEPALPAY */}
                {/* <div
                  style={{
                    fontWeight: "700",
                    color: "#d32f2f",
                    letterSpacing: "1px",
                    fontSize: "14px",
                    marginTop: "6px",
                  }}
                >
                  NEPALPAY
                </div> */}

                <div
                  style={{
                    fontSize: "13px",
                    color: "#555",
                    marginBottom: "14px",
                  }}
                >
                  Scan & Pay
                </div>

                {/* QR CODE */}
                {(() => {
                  const data = qrResponse ?? {};
                  const candidate =
                    data.qrImageUrl ||
                    data.qrImage ||
                    data.qr ||
                    data.qrCode ||
                    data.data?.qrImage ||
                    data.data;

                  if (candidate) {
                    const src =
                      typeof candidate === "string"
                        ? candidate.startsWith("data:") ||
                          candidate.startsWith("http")
                          ? candidate
                          : `data:image/png;base64,${candidate}`
                        : candidate?.url || candidate?.image;

                    if (src) {
                      return (
                        <div
                          style={{
                            padding: "8px",
                            border: "2px dashed #e0e0e0",
                            borderRadius: "8px",
                            marginBottom: "14px",
                          }}
                        >
                          <img
                            src={src}
                            alt="QR Code"
                            style={{ width: "220px", height: "220px" }}
                          />
                        </div>
                      );
                    }
                  }

                  return <p className="text-muted">QR not available</p>;
                })()}

                <div style={{ marginBottom: "10px" }}>
                  <img
                    src={logo}
                    // alt="Merchant Logo"
                    style={{ height: "60px", objectFit: "contain" }}
                  />
                </div>
                {/* Instruction */}
                <div style={{ fontSize: "12px", color: "#777" }}>
                  Use mobile banking app
                  <br />
                  supporting <strong>NEPALPAY</strong>
                </div>
              </div>

              {/* STATUS */}
              <div className="text-center mt-4">
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: getStatusColor(),
                  }}
                >
                  {wsStatus === "COMPLETED"
                    ? "Payment Successful"
                    : wsStatus === "FAILED"
                    ? "Payment Failed"
                    : wsStatus === "PARSED"
                    ? "Processing Payment..."
                    : wsStatus === "ENTR"
                    ? "Waiting for Scan..."
                    : "Connecting..."}
                </div>

                {(wsStatus === "ENTR" || wsStatus === "PARSED") && (
                  <div className="mt-2">
                    <Spinner size="sm" />
                  </div>
                )}

                <div
                  style={{
                    fontSize: "13px",
                    color: "#757575",
                    marginTop: "6px",
                  }}
                >
                  {wsMessage || "Please scan the QR to continue"}
                </div>
              </div>

              {/* LOGS */}
              <details className="mt-4">
                <summary style={{ cursor: "pointer", fontWeight: 600 }}>
                  View Connection Logs
                </summary>
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "10px",
                    borderRadius: "6px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    fontSize: "12px",
                    fontFamily: "monospace",
                    marginTop: "8px",
                  }}
                >
                  {wsLogs.length ? wsLogs.join("\n") : "No logs yet"}
                </div>
              </details>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          {wsStatus === "COMPLETED" ? (
            <Button
              color="success"
              onClick={() => {
                setQrModalOpen(false);
                dispatch(clearCart());
                // navigate("/payment-success", {
                //   state: { orgData, orderResponse, paymentType },
                // });

                navigate(`/${orgData?.orgCode}`);
              }}
            >
              Continue
            </Button>
          ) : (
            <>
              <Button
                color="info"
                onClick={handleCheckNqrStatus}
                disabled={checkStatusLoading}
              >
                {checkStatusLoading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Checking...
                  </>
                ) : (
                  "Check Status"
                )}
              </Button>
              <Button
                color="danger"
                onClick={() => {
                  setQrModalOpen(false);
                  wsRef.current?.close();
                }}
              >
                Cancel Payment
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default CustomerCheckout;
